import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { WoodCertificationUpdateCertificationsDispatchResultDto } from '../dtos/wood-certification/models';

@Injectable({
  providedIn: 'root',
})
export class WoodCertificationPlanningOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  updateCertifications = (woodCertificationId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationUpdateCertificationsDispatchResultDto>({
      method: 'PUT',
      url: `/api/orchestrator/wood-certification-planning-orchestrator/certifications/${woodCertificationId}`,
    },
    { apiName: this.apiName,...config });
}